import TablesContainer from './container';

export default TablesContainer;
